import { render, staticRenderFns } from "./ManageNiche.vue?vue&type=template&id=7cc6baf9&scoped=true&"
import script from "./ManageNiche.vue?vue&type=script&lang=js&"
export * from "./ManageNiche.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=7cc6baf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc6baf9",
  null
  
)

export default component.exports